<div class="photo">
  <mat-chip-set>
    @if (image) {
    <mat-chip
      disabled
      class="app-img mat-elevation-z1"
      [ngStyle]="{
        'background-image': 'url(' + image + ')',
        'width': size,
        'height': size
      }"
    ></mat-chip>
    }
    @if (!image) {
    <mat-chip
      [ngStyle]="{
        'width': size,
        'height': size,
        'font-size': 'calc(' + size + ' * 0.5)'
      }"
      disabled
      >{{ appInitials }}</mat-chip
    >
    }
  </mat-chip-set>
</div> 